import { renderRoot } from 'quartz-core/client';
import UIApplication from 'UIComponents/app/UIApplication';
import { createBrowserHistory } from 'history';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';

// Import extra I18n data
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Redux

import { Provider } from 'react-redux';
import { configureStore } from './utils/configureStore';
import { startApp } from './actions/AppActions';
import { getAuth } from './actions/AuthActions';

// Configure the router
import { Router } from 'react-router-dom';
import { getRootUrl } from './utils/urls';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { setupCookieBanner } from './utils/cookieUtils';
import PortalIdParser from 'PortalIdParser';
import { ChatActions } from './reducers/chat';
import AppLayout from './components/AppLayout';
import { getPreferredLocale } from './utils/localeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export class App {
  constructor() {
    this.store = configureStore();
  }
  start() {
    const locale = getPreferredLocale();
    const I18nPublicProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nPublicProvider.setLocale({
      locale,
      langEnabled: true
    });
    const authPromise = PortalIdParser.get() ? this.startAuth() : Promise.resolve();
    return Promise.all([authPromise, I18nPublicProvider.register(lang), registerAllData(I18nPublicProvider)]).then(() => {
      setDocumentTitle('app.htmlTitle');
      this.store.dispatch(startApp());
      this.store.dispatch(ChatActions.init());
      this.render();
    }).then(setupCookieBanner).catch(err => setTimeout(() => {
      throw err;
    }));
  }
  startAuth() {
    return this.store.dispatch(getAuth());
  }
  setupCookieBanner() {}
  render() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "livechat-unboxing-ui",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          history: historyAdapter(history),
          config: rhumbConfig,
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(AppLayout, {})
          })
        })
      })
    }));
  }
}